import React from "react";
import { Breadcrumb } from "../../../../components/Breadcrumb";
import { NewButton, SaveButton } from "../../../../components/Buttons";

export const Modification = () => {
    document.title = "Modifikasiya";

    const menu = [
        { name: "Ana səhifə", value: "/" },
        { name: "Məhsullar", value: "/products" },
        { name: "Parametrlər", value: "/products/parameters" },
        { name: "Modifikasiya", value: "/products/parameters/modification", current: true },
    ];

    return (
        <div>
            <Breadcrumb menu={menu} />
            <div className="container">
                <article>
                    <h2 className="my-4">Modifikasiya</h2>
                    <p>
                        Bir məhsula müxtəlif modifikasiyalar təyin etmək olar. Bunun üçün məhsul kartında modifikasiya bölməsinə keçid edərək
                        <NewButton>Yeni modifikasiya</NewButton> düyməsini sıxıb, modifikasiyanın adını və növünü təyin edib <SaveButton /> düyməsini sıxmaq
                        lazımdır. Misal üçün, kitab məhsuluna cild, müəllif, nəşriyyat və s. modifikasiya əlavə edib daha sonrakı axtarış əməliyyatlarında
                        istifadə edə bilərsiniz. Yeni modifikasiya əlavə etdikdən sonra <SaveButton /> düyməsini sıxmaq lazımdır.
                    </p>
                    <img src="/images/products/parameters/modification.gif" alt="Modifikasiya" />
                </article>
            </div>
        </div>
    );
};
